import React, { Component } from 'react'

export default class Gameplan extends Component {
    render() {
        return (
            <div className="container">
                <h4 class="center-align">SPIELPLAN UNSERER HEIMSPIELE</h4>
                <h5 class="center-align">Zur Zeit findet kein Spiel statt, darum kann leider auch kein 
                Banden-Bingo gespielt werden. Versuche es doch an folgenden Daten nochmals:</h5><br />
                <h6>FR., 00.00.2017, 20.00 UHR CLUB A - : - CLUB C </h6>
                <h6>SA., 00.00.2017, 20.00 UHR CLUB A - : - CLUB H </h6>
                <h6>MI., 00.00.2017, 20.00 UHR CLUB A - : - CLUB E  </h6>
                <h6>FR., 00.00.2017, 20.00 UHR CLUB A - : - CLUB D  </h6>
                <h6>MI., 00.00.2017, 20.00 UHR CLUB A - : - CLUB C   </h6>
                <h6>FR., 00.00.2017, 20.00 UHR CLUB A - : - CLUB H   </h6>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Gameplan.jsx